'use strict';

var baggagesObserverMixin = require('../mixins/baggages_observer.mixin');
var baggagesManagerMixin = require('../mixins/baggages_manager.mixin');

module.exports = Odigeo.Model.extend(baggagesObserverMixin.extend(baggagesManagerMixin.extend({

    loadData: function() {
        var passengerSegments = this.getPassengerSegments();
        var expanded;
        var data = {
            collapsed: passengerSegments.collapsed,
            totalPieces: 0,
            expandedContainer: 0,
        };
        if (this.isExpandableTrip()) {
            expanded = passengerSegments.expanded;
            Odigeo._.extend(data, {
                departure: expanded.FIRST,
                return: expanded.SECOND,
            });
        }
        this.set(data);
    },

    getPassengerSegments: function() {
        var data = Odigeo._.reduce(this.getBaggageAllRowsWithCid(), this.mapExpandedSegments, {
            collapsed: {},
            expanded: [],
        }, this);
        return {
            collapsed: Odigeo._.mapValues(data.collapsed, this.mapCollapsedSegmentOptions, this),
            expanded: data.expanded,
        };
    },

    mapExpandedSegments: function(data, passengerRow) {
        var cid = passengerRow.cid;
        var idPassenger = passengerRow.idPassenger;
        var idRow = passengerRow.idRow;
        var options = this.sortOptions(this.getAllBaggagesOptions({idPassenger: idPassenger, idRow: idRow}));
        this.attachCollapsedData(data, cid, passengerRow, idPassenger, idRow, options);
        if (Odigeo._.isUndefined(data.expanded[idRow])) {
            data.expanded[idRow] = {};
        }
        options = this.unpackOptions(options);
        data.expanded[idRow][idPassenger] = {
            cid: cid,
            cid2: '',
            idPassenger: idPassenger,
            idRow: idRow,
            options: options,
            passenger: this.getPassengerData(idPassenger),
            isSelected: this.isBaggagePreselected(options),
            label: this.widget.options.translations.noBagsLabel,
            pieces: 0,
            price: 0,
            primePrice: 0,
            selectedCid: this.getEmptyOptionCid(options),
        };

        return data;
    },

    attachCollapsedData: function(data, cid, passengerRow, idPassenger, idRow, options) {
        if (Odigeo._.isUndefined(data.collapsed[idPassenger])) {
            data.collapsed[idPassenger] = Odigeo._.extend(Odigeo._.pick(passengerRow, 'idPassenger', 'idRow'), {
                cid: cid,
                cid2: '',
                segments: [],
                passenger: this.getPassengerData(idPassenger),
            });
        } else {
            data.collapsed[idPassenger].cid2 = cid;
        }
        data.collapsed[idPassenger].segments[idRow] = options;
    },

    getPassengersData: function() {
        var data = this.get('passengers');
        data = Odigeo._.isObject(data) ? data : {};
        if (Odigeo._.isEmpty(data)) {
            this.set('passengers', {});
        }
        return data;
    },

    getPassengerData: function(id) {
        return (this.getPassengersData())[id];
    },

    unpackOptions: function(options) {
        var processedOptions = Odigeo._.map(options, Odigeo._.bind(function(option) {
            return {
                cid: option.cid,
                price: option.get('price'),
                primePrice: option.get('primePrice') || 0,
                pieces: option.get('pieces'),
                kilos: option.get('kilos'),
                isPreselected: false,
                isSelected: false,
                label: this.getOptionLabel(option, option.get('price')),
            };
        }, this));
        return this.setPreselectedOption(processedOptions);
    },

    getOptionLabel: function(option, price) {
        var translations = this.widget.options.translations;
        var pieces = option.get('piecesToShow');
        var optionLabel = translations.noSelectionLabel;
        var rowLabel = translations.noSelectionLabel;
        var positiveKilos;
        var concept;
        var conceptWithWeight;
        var conceptLabel;
        var formattedPrice;

        if (pieces !== 0) {
            positiveKilos = !Odigeo._.isUndefined(option.get('kilos')) && option.get('kilos') > 0 ? option.get('kilos') : null;
            conceptWithWeight = Odigeo.AB.isDisplayTotalBaggageWeightAllowance && pieces > 1 ?
                translations.dropdownPiecesWithTotalKilos
                : translations.dropdownPiecesWithKilos;
            concept = !Odigeo._.isNull(positiveKilos) ? conceptWithWeight : translations.dropdownPieces;
            conceptLabel = Odigeo.Utils.pluralizeAll(concept, pieces, positiveKilos);
            formattedPrice = Odigeo.Utils.formatCurrency(price);

            rowLabel = Odigeo.AB.isDisplayTotalBaggageWeightAllowance && pieces > 1 ? conceptLabel : pieces + conceptLabel;
            optionLabel = rowLabel + ' - ' + formattedPrice;
        }

        return {
            rowLabel: rowLabel,
            optionLabel: optionLabel,
            priceLabel: formattedPrice,
        };
    },

    isBaggagePreselected: function(options) {
        return !Odigeo._.isUndefined(Odigeo._.find(options, function(option) {
            return option.isSelected && option.pieces !== 0;
        }));
    },

    setPreselectedOption: function(options) {
        var min;
        min = Odigeo._.reduce(options, this.getMinNonZero, {
            index: -1,
            value: Number.MAX_VALUE,
        }, this);
        if (min.index < options.length) {
            options[min.index].isPreselected = true;
            options[min.index].isSelected = true;
        }

        return options;
    },

    getEmptyOptionCid: function(options) {
        var emptyOption = Odigeo._.find(options, function(option) {
            return option.pieces === 0;
        });

        return Odigeo._.get(emptyOption, 'cid', '');
    },

    getMinNonZero: function(minimum, option, index) {
        var pieces = option.pieces;
        var isLower = pieces > 0 && pieces < minimum.value;
        return {
            index: isLower ? index : minimum.index,
            value: isLower ? pieces : minimum.value,
        };
    },

    mapCollapsedSegmentOptions: function(passengerSegments) {
        var firstSegmentOptions = passengerSegments.segments.FIRST;
        var secondSegmentOptions = passengerSegments.segments.SECOND;
        var collapsedSegmentOptions = Odigeo._.extend(passengerSegments, {
            label: this.widget.options.translations.noBagsLabel,
            pieces: 0,
            price: 0,
            primePrice: 0,
        });
        if (Odigeo._.isUndefined(secondSegmentOptions)) {
            collapsedSegmentOptions.options = this.unpackOptions(firstSegmentOptions);
        } else {
            collapsedSegmentOptions.options = this.mapSumSegmentOptions(firstSegmentOptions, secondSegmentOptions);
            collapsedSegmentOptions.options = this.setPreselectedOption(collapsedSegmentOptions.options);
        }
        collapsedSegmentOptions.isSelected = this.isBaggagePreselected(collapsedSegmentOptions.options);
        collapsedSegmentOptions.selectedCid = this.getEmptyOptionCid(collapsedSegmentOptions.options);

        return collapsedSegmentOptions;
    },

    mapSumSegmentOptions: function(firstSegmentOptions, secondSegmentOptions) {
        return Odigeo._.map(firstSegmentOptions, function(firstSegmentOption) {
            var sumSegmentOption;
            var price;
            var primePrice;
            var pieces = firstSegmentOption.get('piecesToShow');
            var kilos = firstSegmentOption.get('kilos');
            var secondSegmentOption = this.findSecondSegmentOption(secondSegmentOptions, pieces, kilos);

            if (Odigeo._.isUndefined(secondSegmentOption)) {
                sumSegmentOption = firstSegmentOption;
            } else {
                kilos = firstSegmentOption.get('kilos') === secondSegmentOption.get('kilos') ? kilos : 0;
                price = firstSegmentOption.get('price') + secondSegmentOption.get('price');
                primePrice = firstSegmentOption.get('primePrice') + secondSegmentOption.get('primePrice');
                sumSegmentOption = {
                    cid: firstSegmentOption.cid,
                    cid2: secondSegmentOption.cid,
                    price,
                    primePrice,
                    pieces,
                    kilos,
                    isPreselected: false,
                    isSelected: false,
                    label: this.getOptionLabel(firstSegmentOption, price),
                };
            }
            return sumSegmentOption;
        }, this);
    },

    findSecondSegmentOption: function(options, pieces, kilos) {
        var secondSegmentOption = this.findOptionWithFilters(options, {
            idRow: 'SECOND',
            pieces: pieces,
            kilos: kilos,
        });
        if (Odigeo._.isUndefined(secondSegmentOption)) {
            secondSegmentOption = this.findOptionWithFilters(options, {
                idRow: 'SECOND',
                pieces: pieces,
            });
        }
        return secondSegmentOption;
    },

    findOptionWithFilters: function(options, filters) {
        return Odigeo._.find(options, function(option) {
            return Odigeo._.every(filters, function(value, key) {
                return option.get(key) === value;
            });
        });
    },

    getSegmentBaggage: function(segmentType) {
        return this.get(segmentType);
    },

    getAllBaggage: function() {
        return !this.isExpandableTrip() ? this.getSegmentBaggage('collapsed')
            : Odigeo._.values(this.getSegmentBaggage('departure')).concat(Odigeo._.values(this.getSegmentBaggage('return')));
    },

    updateBaggageData: function(rowType, idPassenger, optionCid) {
        var selectedOption = this.selectOption(rowType, idPassenger, optionCid);
        this.updateModelAfterSelect(rowType, idPassenger, selectedOption);
    },

    selectOption: function(type, idPassenger, optionCid) {
        var baggageItems = this.get(type);
        var passengerItems = baggageItems[idPassenger];
        var options = passengerItems.options;
        var selectedOption = {};
        Odigeo._.map(options, function(option) {
            option.isSelected = option.cid === optionCid;
            if (option.isSelected) {
                selectedOption = option;
            }
            return option;
        });
        var hasPieces = selectedOption.pieces > 0;
        passengerItems.options = options;
        passengerItems.isSelected = hasPieces;
        passengerItems.label = hasPieces ? selectedOption.label.rowLabel : this.widget.options.translations.noBagsLabel;
        passengerItems.price = selectedOption.price;
        passengerItems.primePrice = selectedOption.primePrice;
        passengerItems.pieces = selectedOption.pieces;
        passengerItems.selectedCid = selectedOption.cid;
        this.set(type, baggageItems);
        return selectedOption;
    },

    updateModelAfterSelect: function(type, idPassenger, selectedOption) {
        if (this.isExpandableTrip() && type === 'collapsed') {
            this.selectOption('departure', idPassenger, selectedOption.cid);
            this.selectOption('return', idPassenger, selectedOption.cid2);
        }
        this.updatePriceAndPieceCount();
    },

    updatePriceAndPieceCount: function() {
        var items = this.getAllBaggage();

        var totalPrice = this.getSumOfCollectionProperty(items, 'price');
        var totalPrimePrice = this.getSumOfCollectionProperty(items, 'primePrice');
        var totalPieces = this.getSumOfCollectionProperty(items, 'pieces');

        this.set('totalPieces', totalPieces);
        this.widget.view.updatePriceLabel(totalPrice, totalPrimePrice);
    },

    getSumOfCollectionProperty: function(collection, propertyName) {
        return Odigeo._.reduce(collection, function(total, item) {
            return total + item[propertyName];
        }, 0);
    },

    getTotalPieces: function() {
        return this.get('totalPieces');
    },

    getSelectedOptionPieces: function(type, idPassenger) {
        var baggageItems = this.get(type);
        var options = baggageItems[idPassenger].options;
        var selectedOption = Odigeo._.find(options, function(option) {
            return option.isSelected === true;
        });

        return Odigeo._.isUndefined(selectedOption) ? 0 : selectedOption.pieces;
    },

    hasSegmentSelectedOptionNotPreselected: function(type) {
        var baggageItems = this.get(type);
        return Odigeo._.reduce(baggageItems, function(selectedNotPreselected, baggageItem) {
            var isSelectedOptionNotPreselected = !Odigeo._.isUndefined(Odigeo._.find(baggageItem.options, function(option) {
                return option.isSelected && !option.isPreselected && option.pieces > 0;
            }));
            return isSelectedOptionNotPreselected || selectedNotPreselected;
        }, false);
    },

    saveBaggageData: function() {
        var items = this.getAllBaggage();
        Odigeo._.each(items, Odigeo._.bind(function(item) {
            if (item.selectedCid !== '') {
                this.updateBaggageSelection({
                    newOptionCid: item.selectedCid,
                    isUserAction: true,
                    triggerEvents: true,
                });
                Odigeo.trigger('smart-nag-baggage:updateSelectedBaggageFromSmartnag');
            }
        }, this));
    },

    activateExpandedStatus: function() {
        this.set('expandedContainer', 1);
    },

    getExpandedStatus: function() {
        return this.get('expandedContainer');
    },

    setPassengersData: function(data) {
        var passengersData = {};
        Odigeo._.each(data, function(passenger) {
            var id = passenger.id.replace('passengers', '');
            passengersData[id] = {
                name: passenger.name,
                firstLastName: passenger.firstLastName,
            };
        });
        this.set('passengers', passengersData);
    },

    getPassengerCount: function() {
        return Odigeo._.size(this.get('collapsed'));
    },

    getTrackingFlightType: function() {
        var flightType = this.getFlightType();
        return flightType === 'ONE_WAY' ? 'OW' : flightType === 'ROUND_TRIP' ? 'RT' : 'MD';
    },

    getSelectedSegments: function(segmentType) {
        return Odigeo._.filter(this.getSegmentBaggage(segmentType), {isSelected: true});
    },

    allPassengersHaveSelectedBaggage: function() {
        var allBaggagePerPassenger = Odigeo._.groupBy(this.getAllBaggage(), 'idPassenger');
        return Odigeo._.reduce(allBaggagePerPassenger, function(memo, value) {
            return memo && Odigeo._.sum(value, 'pieces') > 0;
        }, true);
    },

    isExpandableTrip: function() {
        return !this.isAnItineraryTrip() && !this.isOneWayTrip();
    },

    getMainTemplateData: function() {
        return {
            translations: this.widget.options.translations,
            isOneWayTrip: this.isOneWayTrip(),
            isExpandableTrip: this.isExpandableTrip(),
        };
    },
})));
